export default "__VITE_ASSET__CyGPU_uz__"